export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref12108.af4e97e1.jpg";